<template>
  <v-card>
    <v-card-title class="primary white--text">
      Карты режимов
    </v-card-title>
    <v-card-text>
      Бла бла бла 0 руб/мес
      <div>Статус: вкл</div>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="success" to="simple-card">Подробнее</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
}
</script>
